export default __webpack_public_path__ + "static/media/footer-Img.6f4e3f5b.svg";